function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.48 1.333H6.667L5.333 2.667V4h-2L2 5.333v8l1.333 1.334h6l1.334-1.333V12h2L14 10.667V4c-1.04-1.04-1.48-1.627-2.52-2.667zm-.713 1.334h.013l1.247 1.247.6.6h-1.854V2.666h-.006zM9.327 12.78l-.554.554H3.88l-.553-.554v-6.9l.553-.553h1.447v5.333l1.333 1.333h2.667v.787zm3.333-2.666l-.093.093-.46.46H7.213l-.46-.46-.093-.094V3.22l.093-.093.46-.46h2.22v3.18h3.227v4.273-.006z",
  fill: "#002F34"
});

const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref);

export default SvgCopy;